import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/ap-logo.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-5808e912")

_pushScopeId("data-v-5808e912")
const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "pane" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  style: {"max-width":"400px"},
  alt: "AccidentPlan Logo"
}, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createVNode("h3", null, "Login", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Submit ")
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createVNode("h3", null, "Authenticate", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Submit ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.authState !== _ctx.AuthStates.LOGGED_IN_NO_VALIDATION)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_el_form, {
              onSubmit: _withModifiers(_ctx.login, ["prevent"])
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  placeholder: "User ID",
                  class: "login-input",
                  modelValue: _ctx.userIdText,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.userIdText = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_input, {
                  placeholder: "Password",
                  type: "password",
                  class: "login-input",
                  modelValue: _ctx.passwordText,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.passwordText = $event))
                }, null, 8, ["modelValue"]),
                _withDirectives(_createVNode(_component_el_button, {
                  "native-type": "submit",
                  type: "primary"
                }, {
                  default: _withId(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 512), [
                  [_directive_loading, _ctx.authState === _ctx.AuthStates.LOGGING_IN]
                ])
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.authState === _ctx.AuthStates.LOGGED_IN_NO_VALIDATION)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_form, {
              onSubmit: _withModifiers(_ctx.validation, ["prevent"])
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  placeholder: "Verification Code",
                  class: "login-input",
                  modelValue: _ctx.shortcodeText,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.shortcodeText = $event))
                }, null, 8, ["modelValue"]),
                _withDirectives(_createVNode(_component_el_button, {
                  "native-type": "submit",
                  type: "primary"
                }, {
                  default: _withId(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 512), [
                  [_directive_loading, _ctx.authState === _ctx.AuthStates.LOGGING_IN]
                ])
              ]),
              _: 1
            }, 8, ["onSubmit"]),
            _createVNode("p", null, "Email sent to " + _toDisplayString(_ctx.userIdText), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})